 <template id="template-input">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      v-on:toggle-field="showSettings=!showSettings"
      v-on:collapse-field="collapse=!collapse"
    />
    <!-- input content -->
    <b-collapse
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      id="collapse-1"
      :class="isPreview ? 'mt-0': 'mt-5'"
      v-model="collapse"
    >
      <b-row v-if="fieldData.isConditional=='1' && !isPreview">
        <b-col cols="12" class="text-right">
          <b-button
            variant="outline-dark"
            disabled
            title="This field is hidden by default and will display bt is controlled element"
          >
            <font-awesome-icon icon="eye-slash" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-left">
          <b-form-group
            :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
            :id="fieldData.id"
            :description="fieldData.helperText[selectedLanguage]"
            :invalid-feedback="msg.xss ? $t('createProfile.invalidInputMessage') : fieldData.validationMessage[selectedLanguage]"
          >
            <label>
              <span
                v-if="fieldData.validation && JSON.parse(fieldData.validation.required)"
                class="required-span"
              >*</span>
              {{(form1.enableSectionFieldEnumeration == 1 ? (sectionIndex+1)+'.'+(fieldIndex+1) :'')}} {{label ? label : fieldData.label[selectedLanguage]}}
            </label>
            <b-form-input
              :class="$store.state.rightAlign ? 'text-right' : 'text-left'"
              :disabled="isDisabled == 1"
              trim
              v-model="name"
              @input="onInputType"
              @blur="checkValidate"
              :state="
                isFocus
                  ? msg.xss
                    ? false
                    : fieldData.validation &&
                      JSON.parse(fieldData.validation.required)
                    ? !$v.name.required
                      ? false
                      : true
                    : null
                  : null
              "
              @focus="isFocus = true"
              :placeholder="
                placeholder
                  ? placeholder
                  : fieldData.placeholder[selectedLanguage]
              "
            ></b-form-input>
            <span v-if="msg.min" class="float-left text-danger"
              >{{ msg.min }}&nbsp;</span
            >
            <span v-if="msg.max" class="float-left text-danger"
              >{{ msg.max }}&nbsp;</span
            >
            <!-- <span :class="$store.state.rightAlign ? 'text-right text-danger' : 'text-left text-danger'"  v-if="!$v.name.url">{{$t('validations.invalidFormat')}}&nbsp;</span> -->
          </b-form-group>
        </b-col>
      </b-row>

      <!-- show advance field options -->
      <b-modal
        cancel-title="Close"
        ok-title="save"
        @ok="onSaveData"
        size="lg"
        v-model="showSettings"
        scrollable
        title="Input Advanced Settings"
      >
        <AdvanceSettings
          :fieldData="fieldData"
          v-on:toggle-field="showSettings=!showSettings"
          :sectionIndex="sectionIndex"
          :fieldIndex="fieldIndex"
        />
      </b-modal>
    </b-collapse>
    <b-alert
      v-model="showErrorAlert"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="danger"
      dismissible
      solid
      :change="hideAllError()"
    >One or more Errors Found, please have a look.!</b-alert>
  </div>
</template>

<script>
import { required, url } from "vuelidate/lib/validators";
import AdvanceSettings from "../advanceSettingsCompenent";
import MenuButtons from "../menuButtons";
import { mapGetters, mapState } from "vuex";
import { EventBus } from "@/event-bus.js";
import { Validate } from "../../helpers";
import _ from "lodash";

export default {
  name: "WebSiteGroup",
  components: {
    AdvanceSettings,
    MenuButtons,
  },
  data() {
    return {
      isHidden: false,
      condition: {},
      showToolTip: false,
      isFocus: false,
      isError: false,
      isSuccess: false,
      label: undefined,
      placeholder: undefined,
      helperText: undefined,
      tooltipText: undefined,
      showSettings: false,
      msg: [],
      isRequired: 1,
      collapse: true,
      name: this.fieldData.value || null,
      showErrorAlert: false,
    };
  },
  created() {
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (this.hasActiveXssError()) {
        this.$store.state.validFields = false;
        this.isFocus = true;
        this.fieldData.isInValid = true;
        return;
      }
      if (value == "progress") {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
      } else {
        if (
          this.fieldData.validation &&
          this.fieldData.validation.required == 1
        ) {
          if (this.$v && !this.$v.$invalid) {
            // alert("submit success");
            this.$store.state.validFields = true;
            this.fieldData.isInValid = false;
          } else {
            this.$store.state.validFields = false;
            this.isFocus = true;
            this.fieldData.isInValid = true;
          }
        }
      }
    });

    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      //   // console.log("OnInvalidFieldCatch url", inValidData, this.fieldData.id)
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  mounted() {
    this.isRequired = this.fieldData.validation.required;
    if (
      this.$route.name == "userform" ||
      this.$route.name == "EmployeeUserFormPage" ||
      this.$route.name == "EmployeeComplaintFormPage" ||
      this.$route.name == "ViewComplaints"
    ) {
      this.setFieldValue();
    }
  },
  validations: {
    name: {
      required,
      // url
      // https://asa.com //valid formatt
    },
  },
  computed: {
    ...mapGetters([
      "form1",
      "selectedLanguage",
      "userForm",
      "userFormSubmitArray",
    ]),
    ...mapState(["toggleAllCoppalse"]),
  },

  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    },

    name(value) {
      if (this.fieldData.validation && this.fieldData.validation.min) {
        this.checkLength(this.fieldData.validation.min, "min");
      }
      if (this.fieldData.validation && this.fieldData.validation.max) {
        this.checkLength(this.fieldData.validation.max, "max");
      }
    },
  },

  methods: {
    checkLength(length, type) {
      if (type === "min") {
        if (this.name.length < parseInt(length)) {
          this.msg["min"] =
            this.fieldData.minValidateMessage[this.selectedLanguage] ||
            "Not valid";
        } else {
          this.msg["min"] = "";
        }
      } else if (type === "max") {
        if (this.name.length > parseInt(length)) {
          this.msg["max"] =
            this.fieldData.maxValidateMessage[this.selectedLanguage] ||
            "Not valid";
        } else {
          this.msg["max"] = "";
        }
      } else {
        return true;
      }
    },

    checkXss(value) {
      if (!Validate.noXSS(value)) {
        this.msg["xss"] = true;
        return true;
      }
      this.msg["xss"] = false;
      return false;
    },

    hasActiveXssError() {
      return Object.keys(this.msg).some((key) => key.startsWith("xss") && this.msg[key]);
    },

    hideAllError() {
      // // console.log("--------------777777777777777777777777");
      if (this.showErrorAlert) {
        this.showErrorAlert = false;
      }
    },

    checkValidate() {
      if (this.name.length >= 3) {
        (this.isError = false), (this.isSuccess = true);
      } else {
        (this.isError = true), (this.isSuccess = false);
      }
    },

    setFieldValue() {
      this.$store.state.getUserFormSubmitArray.length &&
        this.$store.state.getUserFormSubmitArray.map((a, index) => {
          if (a.elementId === this.fieldData.id) {
            a.elements.map((el) => {
              return (this.name = el.postValue || null);
            });
          }
        });
    },

    onInputType(e) {
      const registerData = _.clone(this.$store.state.registerData);
      const hasXss = this.checkXss(e);

      if (
        this.$route.name == "userform" ||
        this.$route.name == "EmployeeUserFormPage" ||
        this.$route.name == "EmployeeComplaintFormPage" ||
        this.$route.name == "ViewComplaints"
      ) {
        this.name = e;
        if (e && e.length > 0 && !hasXss) {
          registerData[this.fieldData.id] = e;
        } else {
          delete registerData[this.fieldData.id];
        }
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;

        if (!hasXss) {
          this.$store.state.userFormSubmitArray.map((a, index) => {
            if (a.elementId === this.fieldData.id) {
              a.elements[0] = {
                postValue: e,
                postName:
                  (this.fieldData.attributes &&
                    this.fieldData.attributes.postName) ||
                  "postNameWebSite",
              };
            }
          });
        }
      }
    },
    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.required-span {
  font-size: 24px;
  margin-left: 3px;
  color: red;
}
</style>

